import script from "./OrderPaid.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPaid.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPaid.vue?vue&type=style&index=0&id=2c8d4117&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8d4117"]])

export default __exports__